export const DEFAULT_HTTP_REQUEST_TIMEOUT_MS = 30_000;

type AbortSignalStatic = {
  any?: (signals: AbortSignal[]) => AbortSignal;
} & typeof AbortSignal;

const mergeAbortSignals = (signals: AbortSignal[]): AbortSignal => {
  const combineAny = (AbortSignal as AbortSignalStatic).any;
  if (typeof combineAny === 'function') {
    return combineAny(signals);
  }

  const controller = new AbortController();
  const abortMerged = (): void => {
    controller.abort();
  };

  for (const signal of signals) {
    if (signal.aborted) {
      abortMerged();
      return controller.signal;
    }
    signal.addEventListener('abort', abortMerged, { once: true });
  }

  return controller.signal;
};

export const buildRequestTimeoutSignal = (userSignal?: AbortSignal | null): AbortSignal => {
  const timeoutSignal = AbortSignal.timeout(DEFAULT_HTTP_REQUEST_TIMEOUT_MS);
  if (!userSignal) {
    return timeoutSignal;
  }
  return mergeAbortSignals([userSignal, timeoutSignal]);
};
